
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/order/voucher",
      function () {
        return require("private-next-pages/order/voucher/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/order/voucher"])
      });
    }
  